module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_19.5ad529eb.pdf";